import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./utils/Navbar";
import Funnel from "./pages/Funnel";
import Footer from "./utils/Footer/Footer";
import { FaPhone, FaWhatsapp } from "react-icons/fa6";
import Courses from "./pages/Courses";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import PopupNotification from "./utils/Pop/PopUp";
import ContactFormMain from "./main/home/Contactform/ContactFormMain";
import TermsPolicy from "./pages/PrivacyPolicy";

function App() {
  const { pathname } = useLocation();


  const Whatsapp = () => {
    const phoneNumber = "919361319990"; 

    // Optional pre-filled message
    const message = "Hello, I would like to know more about your courses!";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    // Open WhatsApp chat in a new tab
    window.open(url, "_blank");
  };

  const call = () => {
    const phoneNumber = "919025006947";
    window.location.href = `tel:${phoneNumber}`;
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return (
    <div id="main-element" className="bg-secondary relative overflow-x-hidden">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/funnels" element={<Courses />} />
        <Route path="/overview" element={<Funnel />} />
        <Route path="/ContactUs" element={<ContactFormMain />} />
        <Route path="/privacy" element={<TermsPolicy />} />
      </Routes>
      <Footer />
      <div className="fixed z-10 bottom-8 right-8 flex flex-col gap-4">
        {pathname !== "/overview" && (
          <div
            onClick={call}
            className="bg-white text-primary rounded-full p-4 cursor-pointer shadow-lg">
            <FaPhone size={20} />
          </div>
        )}

        <div
          onClick={Whatsapp}
          className="bg-white text-primary rounded-full relative  p-4 cursor-pointer shadow-lg whatsapp ">
          <FaWhatsapp size={22} />
        </div>
      </div>
      <Toaster />
    </div>
  );
}

export default App;
